"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[233],{

/***/ 97712:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ structuredDataAggregateReviews; },
/* harmony export */   "n": function() { return /* binding */ structuredData; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(828);


var getVariantsStructuredData = function(variants, productCondition) {
    var inStock = "https://schema.org/InStock";
    var outOfStock = "https://schema.org/OutOfStock";
    return variants.map(function(variant) {
        return {
            "@type": "Offer",
            priceCurrency: variant.pricing.price.gross.currency,
            price: (variant.pricing.price.gross.amount + variant.pricing.borrowerFee.gross.amount).toFixed(2),
            itemCondition: (productCondition === null || productCondition === void 0 ? void 0 : productCondition.slug) === "new" || (productCondition === null || productCondition === void 0 ? void 0 : productCondition.slug) === "new-with-tags" ? "https://schema.org/NewCondition" : "https://schema.org/UsedCondition",
            availability: variant.quantityAvailable > 0 ? inStock : outOfStock
        };
    });
};
function getProductBrand(product) {
    var ref;
    var designerAttribute = product === null || product === void 0 ? void 0 : (ref = product.attributes) === null || ref === void 0 ? void 0 : ref.find(function(param) {
        var attribute = param.attribute;
        return (attribute === null || attribute === void 0 ? void 0 : attribute.name) === "Designer";
    });
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((designerAttribute === null || designerAttribute === void 0 ? void 0 : designerAttribute.values) || [], 1), designerValue = ref1[0];
    return (designerValue === null || designerValue === void 0 ? void 0 : designerValue.name) || "";
}
var getSku = function(variants) {
    if (Array.isArray(variants) && variants.length > 0) {
        var _sku;
        return (_sku = variants[0].sku) !== null && _sku !== void 0 ? _sku : "";
    }
    return "";
};
var structuredData = function(product) {
    var ref, ref1;
    var images = product.images.map(function(image) {
        return new URL(image.url);
    });
    var productConditionAttribute = product === null || product === void 0 ? void 0 : (ref = product.attributes) === null || ref === void 0 ? void 0 : ref.find(function(attr) {
        return attr.attribute.slug === "condition";
    });
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((productConditionAttribute === null || productConditionAttribute === void 0 ? void 0 : productConditionAttribute.values) || [], 1), productCondition = ref2[0];
    var variants = product.variants;
    var productDescription = "";
    try {
        var ref3, ref4, ref5;
        var descriptionData = JSON.parse(product.description);
        productDescription = (ref5 = (ref4 = descriptionData === null || descriptionData === void 0 ? void 0 : (ref3 = descriptionData.blocks) === null || ref3 === void 0 ? void 0 : ref3.filter(function(block) {
            return (block === null || block === void 0 ? void 0 : block.type) === "paragraph";
        })) === null || ref4 === void 0 ? void 0 : ref4.map(function(block) {
            var ref, ref1;
            return block === null || block === void 0 ? void 0 : (ref = block.data) === null || ref === void 0 ? void 0 : (ref1 = ref.text) === null || ref1 === void 0 ? void 0 : ref1.trim();
        })) === null || ref5 === void 0 ? void 0 : ref5.join(". ");
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error parsing product description:", error);
    }
    productDescription = (product === null || product === void 0 ? void 0 : product.seoDescription) || productDescription || product.name;
    return JSON.stringify((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        "@context": "https://schema.org/",
        "@type": "Product",
        name: product === null || product === void 0 ? void 0 : (ref1 = product.name) === null || ref1 === void 0 ? void 0 : ref1.trim(),
        image: images,
        description: productDescription,
        brand: {
            "@type": "Brand",
            name: getProductBrand(product)
        },
        offers: getVariantsStructuredData(variants, productCondition),
        sku: getSku(variants),
        url: location.href
    }, !!(product === null || product === void 0 ? void 0 : product.productAggregateRating) && {
        aggregateRating: {
            "@type": "AggregateRating",
            ratingValue: product.productAggregateRating.ratingValue,
            ratingCount: product.productAggregateRating.ratingCount
        }
    }));
};
/*
We should be getting this directly from Google, however it is suprisingly difficult.

Using the places API would be the simplest, however since we don't have a physical 
address, it doesn't work.

(Our place_id: ChIJvd_NtezkT2ERjXpVP5iszM0)

https://maps.googleapis.com/maps/api/place/details/json?key={{GOOGLE_PLACES_API_KEY}}&place_id={{PLACE_ID}}&fields=name

The result is "The provided Place ID is no longer valid" - this is just misleading error message :(
see: https://support.google.com/business/thread/120163650/the-provided-place-id-is-no-longer-valid-please-refresh-cached-place-ids-so-stuck?hl=en

So trying using the Google Business Profile API
see: https://developers.google.com/my-business/content/overview

https://mybusiness.googleapis.com/v4/accounts/102488506248101242686/locations/8026778460399333943/reviews?pageSize=1

{
    "reviews": [
      ...
    ],
    "averageRating": 5,
    "totalReviewCount": 18,
}

This can work but requires OAuth with a human user, which can't be automated.  Using a service account might work
according to https://stackoverflow.com/questions/40720692/accessing-google-my-business-api-without-login-using-service-account

Enabling DWD for the service account has security downsides and is not offically supported :(
https://stackoverflow.com/questions/66648811/google-mba-service-account-get-all-locations

...so I haven't tried the DWD approach yet


I think the next step would be just to add these as new model fields under `site_sitesettings` and add them to
the admin dashboard, so they can be manually updated each week.  We can then expose via `Query.Shop` - and move these comments to the GraphQL server code!
*/ var structuredDataAggregateReviews = function() {
    return JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Product",
        name: "The Volte Fashion Rentals",
        aggregateRating: {
            "@type": "AggregateRating",
            ratingValue: "5.0",
            reviewCount: "18"
        }
    });
};


/***/ }),

/***/ 29411:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _temp_views_Search__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12096);

var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (_temp_views_Search__WEBPACK_IMPORTED_MODULE_0__/* .SearchView */ .Z);


/***/ }),

/***/ 80233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G": function() { return /* reexport */ ArticleView; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(42660);
// EXTERNAL MODULE: ./src/core/SEO/Product/structuredData.tsx
var structuredData = __webpack_require__(97712);
// EXTERNAL MODULE: ./src/components/pages/ProductList/ProductListPage.tsx
var ProductListPage = __webpack_require__(39569);
// EXTERNAL MODULE: ./src/hooks/useAttributesFiltering.ts
var useAttributesFiltering = __webpack_require__(79114);
// EXTERNAL MODULE: ./src/hooks/useProductFiltering.ts
var useProductFiltering = __webpack_require__(27698);
// EXTERNAL MODULE: ./src/hooks/useProductLoading.tsx
var useProductLoading = __webpack_require__(66015);
// EXTERNAL MODULE: ./src/utils/designers.tsx
var designers = __webpack_require__(90375);
// EXTERNAL MODULE: ./src/utils/ssr.ts + 1 modules
var ssr = __webpack_require__(11420);
// EXTERNAL MODULE: ./src/components/legacy/index.ts + 40 modules
var legacy = __webpack_require__(92291);
;// CONCATENATED MODULE: ./src/views/AttributedProducts/AttributedProductsView.tsx












var AttributedProductsView = function(param) {
    var attributedProducts = param.data, presetAttributeFilter = param.presetAttributeFilter, categoryFilter = param.categoryFilter;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var attributes = (0,useAttributesFiltering/* useAttributesFiltering */.K)({});
    var presetPriceFilters = attributedProducts === null || attributedProducts === void 0 ? void 0 : attributedProducts.presetPriceFilters;
    var disablePriceFiltering = !!(presetPriceFilters === null || presetPriceFilters === void 0 ? void 0 : presetPriceFilters.lte) || !!(presetPriceFilters === null || presetPriceFilters === void 0 ? void 0 : presetPriceFilters.gte);
    var isDesignerPage = (attributedProducts === null || attributedProducts === void 0 ? void 0 : (ref = attributedProducts.article) === null || ref === void 0 ? void 0 : (ref1 = ref.pageType) === null || ref1 === void 0 ? void 0 : ref1.slug) === ssr/* PageTypes.DESIGNER */.c7.DESIGNER;
    var additionalFilter = presetAttributeFilter || (isDesignerPage ? {
        designer: [
            (0,designers/* getDesignerFromSlug */.$)(attributedProducts === null || attributedProducts === void 0 ? void 0 : attributedProducts.article.slug)
        ]
    } : {});
    delete additionalFilter.priceGte;
    delete additionalFilter.priceLte;
    var locationData = [];
    var isLocationPage = (attributedProducts === null || attributedProducts === void 0 ? void 0 : (ref2 = attributedProducts.article) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.pageType) === null || ref3 === void 0 ? void 0 : ref3.slug) === ssr/* PageTypes.LOCATION */.c7.LOCATION;
    if (isLocationPage) {
        var ref11;
        var postcodes = (ref11 = attributedProducts.article.metadata.find(function(x) {
            return x.key === "postcodes";
        })) === null || ref11 === void 0 ? void 0 : ref11.value;
        locationData = postcodes ? (0,ssr/* parseMetaFilterValue */.FS)(postcodes) : [];
    }
    var ref12 = (0,useProductFiltering/* default */.Z)({
        presetAttributeFilter: additionalFilter,
        presetLocationFilter: locationData,
        presetPriceFilters: presetPriceFilters,
        categoryFilter: categoryFilter
    }), clientFiltered = ref12.clientFiltered, filters = ref12.filters, pricesFilter = ref12.pricesFilter, locationFilter = ref12.locationFilter, handleClearFilters = ref12.handleClearFilters, handleFiltersChange = ref12.handleFiltersChange, handlePricesFilter = ref12.handlePricesFilter, handleLocationFilter = ref12.handleLocationFilter, handleDeliveryFilter = ref12.handleDeliveryFilter, deliveryFilter = ref12.deliveryFilter, hasDeliveryFilter = ref12.hasDeliveryFilter, handleOrderChange = ref12.handleOrderChange, keyword = ref12.keyword, setKeyword = ref12.setKeyword;
    // For non-filter pages, we need to get the default-sort directly from metadata
    var defaultSortMetadata = attributedProducts === null || attributedProducts === void 0 ? void 0 : (ref4 = attributedProducts.article) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.metadata) === null || ref5 === void 0 ? void 0 : ref5.find(function(x) {
        return x.key === "default-sort";
    });
    filters.attributes = (0,_object_spread/* default */.Z)({}, filters.attributes, additionalFilter);
    var filteredAttributes = (attributes === null || attributes === void 0 ? void 0 : attributes.filter(function(x) {
        return x.slug && !(x.slug in additionalFilter);
    })) || [];
    var sortValue = ((ref6 = filters.attributes["default-sort"]) === null || ref6 === void 0 ? void 0 : ref6.at(0)) || (defaultSortMetadata === null || defaultSortMetadata === void 0 ? void 0 : defaultSortMetadata.value) || "best-match";
    var extractedArray = sortValue === null || sortValue === void 0 ? void 0 : sortValue.match(/'([^']+)'/);
    var defaultSort = extractedArray ? extractedArray[1] : sortValue;
    var ref13 = (0,react.useState)(function() {
        return defaultSort;
    }), activeSortOption = ref13[0], setActiveSortOption = ref13[1];
    var mapSortToBackend = function(sort) {
        switch(sort){
            case "price-lowest":
                return "price";
            case "price-highest":
                return "-price";
            case "oldest":
                return "created_at";
            case "newest":
                return "-created_at";
            case "best-match":
                return null; // Backend expects `null` for best match
            default:
                return sort; // Fallback in case of unexpected values
        }
    };
    var ref14;
    filters.sortBy = (ref14 = mapSortToBackend(activeSortOption)) !== null && ref14 !== void 0 ? ref14 : filters.sortBy;
    var onSortChange = function(newSort) {
        setActiveSortOption(newSort); // Update user-facing state
        handleOrderChange({
            value: newSort
        });
    };
    var ref15 = (0,useProductLoading/* useProductLoading */.v)({
        ssrData: attributedProducts === null || attributedProducts === void 0 ? void 0 : (ref7 = attributedProducts.products) === null || ref7 === void 0 ? void 0 : ref7.products,
        ids: {
            categoryId: ""
        },
        filters: filters,
        hasDeliveryFilter: hasDeliveryFilter,
        clientFiltered: clientFiltered,
        postcodes: locationData
    }), products = ref15.products, loading = ref15.loading, pageInfo = ref15.pageInfo, numberOfProducts = ref15.numberOfProducts, handleLoadMore = ref15.handleLoadMore, loadMoreError = ref15.loadMoreError;
    return attributedProducts ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(legacy.MetaWrapper, {
        meta: {
            description: attributedProducts.article.seoDescription,
            title: attributedProducts.article.seoTitle,
            type: "product.attributedProducts",
            image: (products === null || products === void 0 ? void 0 : products.length) && ((ref8 = products[0].thumbnail2x) === null || ref8 === void 0 ? void 0 : ref8.url),
            url: constants/* ssrMode */.$m ? __webpack_require__.g.location.href : window.location.href
        },
        children: [
            isLocationPage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
                className: "structured-data-list",
                type: "application/ld+json",
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: (0,structuredData/* structuredDataAggregateReviews */.l)()
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductListPage/* ProductListPage */.L, {
                title: attributedProducts.article.title,
                seoDescription: attributedProducts.article.seoDescription,
                textContent: attributedProducts.article.content,
                attributes: filteredAttributes,
                clearFilters: handleClearFilters,
                products: products,
                displayLoader: !products.length && loading,
                hasNextPage: !!(pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.hasNextPage),
                numberOfProducts: numberOfProducts,
                activeSortOption: filters.sortBy,
                filters: filters,
                onAttributeFiltersChange: handleFiltersChange,
                onLoadMore: handleLoadMore,
                activeFilters: Object.keys((filters === null || filters === void 0 ? void 0 : filters.attributes) || {
                    undefined: undefined
                }).length - Object.keys(additionalFilter).length,
                onOrder: function(option) {
                    return onSortChange((option === null || option === void 0 ? void 0 : option.value) || null);
                },
                pricesFilter: pricesFilter,
                setPricesFilter: handlePricesFilter,
                locationFilter: locationFilter,
                setLocationFilter: handleLocationFilter,
                disablePriceFiltering: disablePriceFiltering,
                disableLocationFiltering: isLocationPage,
                deliveryFilter: deliveryFilter,
                setDeliveryFilter: handleDeliveryFilter,
                loadMoreError: loadMoreError,
                keyword: keyword,
                setKeyword: setKeyword,
                pageType: attributedProducts === null || attributedProducts === void 0 ? void 0 : (ref9 = attributedProducts.article) === null || ref9 === void 0 ? void 0 : ref9.pageType,
                isFetching: loading,
                aboveProductContent: attributedProducts === null || attributedProducts === void 0 ? void 0 : (ref10 = attributedProducts.article) === null || ref10 === void 0 ? void 0 : ref10.aboveProductContent
            })
        ]
    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(legacy.NotFound, {});
};

;// CONCATENATED MODULE: ./src/views/AttributedProducts/index.tsx


// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(68527);
;// CONCATENATED MODULE: ./src/views/Contact/ContactView.tsx



var ContactView = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(legacy.MetaWrapper, {
        meta: {
            description: "Need immediate assistance?  Kindly contact our customer service team on phone, email or live chat for any Hiring or Lending enquiries.",
            title: "Get Help | The Volte"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                padding: "2rem 0rem",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Container */.W2, {
                    maxW: "1000px",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                                    as: "h1",
                                    padding: "1rem 0rem",
                                    fontSize: "3rem",
                                    textAlign: "center",
                                    fontWeight: 700,
                                    children: "Get the support you need"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
                                    as: "h3",
                                    padding: "0.5rem 0rem",
                                    textAlign: "center",
                                    children: [
                                        "We appreciate your patience. The Volte provides the below resources to help you get the support needed.",
                                        " "
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
                            marginTop: "2rem",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                                    as: "h4",
                                    padding: "0.5rem 0rem",
                                    fontWeight: 700,
                                    children: "Live Chat"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                                    as: "p",
                                    padding: "0.5rem 0rem",
                                    children: "Click the Chat icon at the bottom right of the screen to receive support. If the Volte Bot can't answer your questions, you will be connected to a member of our Customer Support team when they're next available."
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                                    as: "h4",
                                    padding: "0.5rem 0rem",
                                    fontWeight: 700,
                                    children: "Email"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                                    as: "p",
                                    padding: "0.5rem 0rem",
                                    children: "Our Customer Support team is available 24/7 via email. Click the link below to contact us:"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
                                    as: "p",
                                    padding: "0.5rem 0rem",
                                    children: [
                                        " ",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Link */.rU, {
                                            href: "mailto:support@thevolte.com",
                                            children: "support@thevolte.com"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                                    as: "h4",
                                    padding: "0.5rem 0rem",
                                    fontWeight: 700,
                                    children: "Phone"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                                    as: "p",
                                    padding: "0.5rem 0rem",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Link */.rU, {
                                        href: "tel:1800319370",
                                        children: "1800 319 370"
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                                    as: "p",
                                    padding: "0.5rem 0rem",
                                    children: "Monday to Friday, 10:00am to 6:00pm (AEST/AEDT)"
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var Contact_ContactView = (ContactView);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
;// CONCATENATED MODULE: ./src/views/Index/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  font-size: 72px;\n  font-feature-settings: "ss01";\n  line-height: 50px;\n  letter-spacing: 0.5em;\n  text-align: left;\n'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  font-style: normal;\n  line-height: 30px;\n  letter-spacing: 0em;\n  text-align: left;\n  text-transform: uppercase;\n  a {\n    font-weight: 500;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 22px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 50px;\n  letter-spacing: 0.5em;\n  text-align: center;\n\n  &:active {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var Heading = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject());
var Column = emotion_styled_browser_esm/* default.p */.Z.p(_templateObject1());
var Index = emotion_styled_browser_esm/* default.a */.Z.a(_templateObject2(), function(props) {
    return props.theme.colors.primary.base;
});

;// CONCATENATED MODULE: ./src/views/Index/IndexView.tsx





var IndexView = function(param) {
    var data = param.data;
    var ref, ref1, ref2, ref3;
    var isOccasionsPage = data.article.slug === "occasions";
    // Allow for space at start of attribute name, but don't show any that start with a special char
    var items = data.other[0].values.map(function(x) {
        return [
            x.name.trim(),
            x.slug
        ];
    });
    items.sort();
    var entries = new Set();
    // Put numbers after letters
    var alphabeticItems = items.filter(function(x) {
        return /[a-zA-Z]+.*/.test(x[0]);
    });
    var numericItems = items.filter(function(x) {
        return /\d+.*/.test(x[0]);
    });
    (0,_to_consumable_array/* default */.Z)(alphabeticItems).concat((0,_to_consumable_array/* default */.Z)(numericItems)).forEach(function(x) {
        return entries.add(x[0].slice(0, 1));
    });
    // for the link, if its designer go to /designer/, otherwise all go to /page/
    var linktype = data.article.metadata.find(function(x) {
        return x.key === "attribute";
    }).value === "designer" ? "designers" : "page";
    var boxes = (0,_to_consumable_array/* default */.Z)(entries).map(function(x) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
            maxW: "xs",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
                id: x,
                name: x,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading, {
                        children: x
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* SimpleGrid */.MI, {
                        columns: 2,
                        children: items.filter(function(y) {
                            return y[0].slice(0, 1) === x;
                        }).map(function(y) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                    prefetch: false,
                                    href: isOccasionsPage ? "/occasions/".concat(y[1]) : "/".concat(linktype, "/").concat(y[1]),
                                    children: y[0]
                                })
                            });
                        })
                    })
                ]
            })
        }, x);
    });
    var indexes = (0,_to_consumable_array/* default */.Z)(entries).map(function(x) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Index, {
                href: "#".concat(x),
                children: x
            })
        }, x);
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
        padding: "20px",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Flex */.kC, {
                direction: "column",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Center */.M5, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
                            children: data.article.title
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        children: (ref = JSON.parse(data.article.content)) === null || ref === void 0 ? void 0 : (ref1 = ref.blocks) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.text
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* SimpleGrid */.MI, {
                minChildWidth: "30px",
                spacing: "5px",
                children: indexes
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* SimpleGrid */.MI, {
                minChildWidth: "400px",
                spacing: "20px",
                children: boxes
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/lodash.deburr/index.js
var lodash_deburr = __webpack_require__(66688);
var lodash_deburr_default = /*#__PURE__*/__webpack_require__.n(lodash_deburr);
// EXTERNAL MODULE: ./node_modules/lodash.sortby/index.js
var lodash_sortby = __webpack_require__(58254);
var lodash_sortby_default = /*#__PURE__*/__webpack_require__.n(lodash_sortby);
;// CONCATENATED MODULE: ./src/views/Index/DesignerIndexView.tsx






// create regex function to check if A-Z
var letterRegexTest = function(x) {
    return /[a-zA-Z]/.test(x);
};
var DesignerIndexView = function(param) {
    var data = param.data;
    var ref, ref1, ref2, ref3;
    var items = data.other[0].values;
    var lettersObject = "#ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("").reduce(function(acc, letter) {
        acc[letter] = [];
        return acc;
    }, {});
    items.forEach(function(a) {
        var firstLetter = a.name.trim().slice(0, 1).toUpperCase();
        if (letterRegexTest(firstLetter)) {
            if (!lettersObject[firstLetter]) {
                lettersObject["#"].push(a);
            } else {
                lettersObject[firstLetter].push(a);
            }
        } else {
            try {
                var letterDeburr = lodash_deburr_default()(firstLetter);
                if (!lettersObject[letterDeburr]) {
                    lettersObject["#"].push(a);
                } else {
                    lettersObject[letterDeburr].push(a);
                }
            } catch (e) {
                lettersObject["#"].push(a);
            }
        }
    });
    var objectKeys = Object.keys(lettersObject).filter(function(a) {
        return lettersObject[a].length > 0;
    });
    objectKeys.forEach(function(k) {
        lettersObject[k] = lodash_sortby_default()(lettersObject[k], "name");
    });
    var boxes = objectKeys.map(function(x) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
            maxW: "xs",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
                id: x,
                name: x,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading, {
                        children: x
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* SimpleGrid */.MI, {
                        columns: 2,
                        children: lettersObject[x].map(function(y) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                    prefetch: false,
                                    href: "/designers/".concat(y.slug.endsWith("-hire") ? y.slug : y.slug.concat("-hire")),
                                    children: y.name
                                })
                            });
                        })
                    })
                ]
            })
        }, x);
    });
    var indexes = objectKeys.map(function(x) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Index, {
                href: "#".concat(x),
                children: x
            })
        }, x);
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
        padding: "20px",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Flex */.kC, {
                direction: "column",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Center */.M5, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
                            children: data.article.title
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        children: (ref = JSON.parse(data.article.content)) === null || ref === void 0 ? void 0 : (ref1 = ref.blocks) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.text
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* SimpleGrid */.MI, {
                minChildWidth: "30px",
                spacing: "5px",
                children: indexes
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* SimpleGrid */.MI, {
                minChildWidth: "400px",
                spacing: "20px",
                children: boxes
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/views/Index/index.tsx



// EXTERNAL MODULE: ./node_modules/lodash.get/index.js
var lodash_get = __webpack_require__(29208);
var lodash_get_default = /*#__PURE__*/__webpack_require__.n(lodash_get);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-router/esm/react-router.js + 3 modules
var react_router = __webpack_require__(47930);
// EXTERNAL MODULE: ./src/pages/search.ts
var search = __webpack_require__(29411);
// EXTERNAL MODULE: ./src/paths.ts
var paths = __webpack_require__(4032);
// EXTERNAL MODULE: ./src/utils/menu.tsx
var menu = __webpack_require__(62075);
// EXTERNAL MODULE: ./src/components/atoms/index.ts + 6 modules
var atoms = __webpack_require__(23920);
;// CONCATENATED MODULE: ./src/views/Article/Page.tsx





var Page = function(param) {
    var breadcrumbs = param.breadcrumbs, headerImage = param.headerImage, page = param.page;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
        paddingBottom: "10",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "article-page__header",
                style: headerImage ? {
                    backgroundImage: "url(".concat(headerImage, ")")
                } : null,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
                    children: page.title
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                        mb: 4,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(legacy.Breadcrumbs, {
                            breadcrumbs: breadcrumbs
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        className: "article-page__container",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            className: "article-page__content",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.RichTextEditorContent, {
                                jsonData: page.content
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Article_Page = (Page);

;// CONCATENATED MODULE: ./src/views/Article/ArticleView.tsx
















var Meta = function(param) {
    var children = param.children, data = param.data;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var meta = {
        description: data.article.seoDescription,
        title: data.article.seoTitle,
        image: ""
    };
    if (data === null || data === void 0 ? void 0 : (ref = data.attributedProducts) === null || ref === void 0 ? void 0 : (ref1 = ref.products) === null || ref1 === void 0 ? void 0 : ref1.length) {
        var ref6;
        meta.image = data === null || data === void 0 ? void 0 : (ref6 = data.designer) === null || ref6 === void 0 ? void 0 : ref6.designerProducts[0].thumbnail.url;
    }
    if (data === null || data === void 0 ? void 0 : (ref2 = data.featuredProducts) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.products) === null || ref3 === void 0 ? void 0 : ref3.length) {
        var ref7;
        meta.image = data === null || data === void 0 ? void 0 : (ref7 = data.featuredProducts) === null || ref7 === void 0 ? void 0 : ref7.products[0].thumbnail.url;
    }
    if (data === null || data === void 0 ? void 0 : (ref4 = data.other) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.products) === null || ref5 === void 0 ? void 0 : ref5.length) {
        var ref8;
        meta.image = data === null || data === void 0 ? void 0 : (ref8 = data.other) === null || ref8 === void 0 ? void 0 : ref8.products[0].thumbnail.url;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(legacy.MetaWrapper, {
        meta: meta,
        children: children
    });
};
var ArticleView = function(param) {
    var data = param.data, slug = param.params.slug;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
    var ref13 = (0,react.useMemo)(function() {
        var ref, ref1;
        return [
            data === null || data === void 0 ? void 0 : data.article,
            data === null || data === void 0 ? void 0 : (ref = data.featuredProducts) === null || ref === void 0 ? void 0 : (ref1 = ref.backgroundImage) === null || ref1 === void 0 ? void 0 : ref1.url
        ];
    }, [
        data.article
    ]), canDisplay = ref13[0], headerImage = ref13[1];
    var router = (0,next_router.useRouter)();
    var getBreadcrumbs = function(article) {
        return [
            {
                link: (0,react_router/* generatePath */.Gn)(paths/* paths.page */.H.page, {
                    slug: article.slug
                }),
                value: article.title
            }, 
        ];
    };
    var isDesignerPage = (data === null || data === void 0 ? void 0 : (ref = data.article) === null || ref === void 0 ? void 0 : (ref1 = ref.pageType) === null || ref1 === void 0 ? void 0 : ref1.slug) === ssr/* PageTypes.DESIGNER */.c7.DESIGNER;
    var canonicalUrl = isDesignerPage ? "".concat(constants/* siteUrl */.or).concat(paths/* paths.designers */.H.designers, "/").concat(slug).concat(menu/* designerSlugSuffix */.XS) : "".concat(constants/* siteUrl */.or).concat(router.asPath);
    var canonicalRef = (data === null || data === void 0 ? void 0 : data.article) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                rel: "canonical",
                href: canonicalUrl
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
                children: data.article.seoTitle
            })
        ]
    });
    if (isDesignerPage) {
        var ref14;
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Meta, {
            data: data,
            children: [
                canonicalRef,
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AttributedProductsView, {
                    data: data,
                    pagetype: data === null || data === void 0 ? void 0 : (ref14 = data.article) === null || ref14 === void 0 ? void 0 : ref14.pageType
                })
            ]
        });
    }
    if ((data === null || data === void 0 ? void 0 : (ref2 = data.article) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.pageType) === null || ref3 === void 0 ? void 0 : ref3.slug) === ssr/* PageTypes.FILTER */.c7.FILTER) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Meta, {
            data: data,
            children: [
                canonicalRef,
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AttributedProductsView, {
                    data: data,
                    presetAttributeFilter: data.presetAttributeFilter,
                    categoryFilter: data.categoryFilter
                })
            ]
        });
    }
    if ((data === null || data === void 0 ? void 0 : (ref4 = data.article) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.pageType) === null || ref5 === void 0 ? void 0 : ref5.slug) === ssr/* PageTypes.SEARCH */.c7.SEARCH) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Meta, {
            data: data,
            children: [
                canonicalRef,
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(search["default"], {
                    data: data
                })
            ]
        });
    }
    if ((data === null || data === void 0 ? void 0 : (ref6 = data.article) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.pageType) === null || ref7 === void 0 ? void 0 : ref7.slug) === ssr/* PageTypes.LOCATION */.c7.LOCATION) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Meta, {
            data: data,
            children: [
                canonicalRef,
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AttributedProductsView, {
                    data: data,
                    presetAttributeFilter: {}
                })
            ]
        });
    }
    if ((data === null || data === void 0 ? void 0 : (ref8 = data.article) === null || ref8 === void 0 ? void 0 : ref8.slug) === ssr/* PageTypes.CONTACT */.c7.CONTACT) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Meta, {
            data: data,
            children: [
                canonicalRef,
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Contact_ContactView, {})
            ]
        });
    }
    // designer page
    // hacky fix for now
    // probably refactor the whole page/[slug] into
    // something more modularised for dev and seo friendly
    // this pattern can be bloated very fast and hard to maintain in the future
    // initial loading for affected pages will have a bigger payload as well
    if ((data === null || data === void 0 ? void 0 : (ref9 = data.article) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.pageType) === null || ref10 === void 0 ? void 0 : ref10.slug) === ssr/* PageTypes.INDEX */.c7.INDEX && lodash_get_default()(data, "article.slug") === "designers") {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Meta, {
            data: data,
            children: [
                canonicalRef,
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesignerIndexView, {
                    data: data
                })
            ]
        });
    }
    if ((data === null || data === void 0 ? void 0 : (ref11 = data.article) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.pageType) === null || ref12 === void 0 ? void 0 : ref12.slug) === ssr/* PageTypes.INDEX */.c7.INDEX) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Meta, {
            data: data,
            children: [
                canonicalRef,
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IndexView, {
                    data: data
                })
            ]
        });
    }
    return canDisplay ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Meta, {
        data: data,
        children: [
            canonicalRef,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Article_Page, {
                breadcrumbs: getBreadcrumbs(data.article),
                headerImage: headerImage,
                page: data.article
            })
        ]
    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(legacy.NotFound, {});
};

;// CONCATENATED MODULE: ./src/views/Article/index.ts



/***/ }),

/***/ 52921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* reexport */ CategoryView; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/toast/dist/chakra-ui-toast.esm.js + 3 modules
var chakra_ui_toast_esm = __webpack_require__(28609);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(68527);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.mjs
var ai = __webpack_require__(87771);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(42660);
// EXTERNAL MODULE: ./src/providers/TikTokPixelProvider.tsx + 45 modules
var TikTokPixelProvider = __webpack_require__(48841);
// EXTERNAL MODULE: ./src/components/legacy/index.ts + 40 modules
var legacy = __webpack_require__(92291);
// EXTERNAL MODULE: ./src/components/pages/ProductList/ProductListPage.tsx
var ProductListPage = __webpack_require__(39569);
// EXTERNAL MODULE: ./src/hooks/useAttributesFiltering.ts
var useAttributesFiltering = __webpack_require__(79114);
// EXTERNAL MODULE: ./src/hooks/useDeclinedOrderDiscountVoucher.ts
var useDeclinedOrderDiscountVoucher = __webpack_require__(51991);
// EXTERNAL MODULE: ./src/hooks/useProductFiltering.ts
var useProductFiltering = __webpack_require__(27698);
// EXTERNAL MODULE: ./src/hooks/useProductLoading.tsx
var useProductLoading = __webpack_require__(66015);
;// CONCATENATED MODULE: ./src/views/Category/CategoryView.tsx














var CategoryView = function(param) {
    var category = param.data, isSearchPage = param.isSearchPage;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var attributes = (0,useAttributesFiltering/* useAttributesFiltering */.K)({
        categoryId: category === null || category === void 0 ? void 0 : category.id
    });
    var toast = (0,chakra_ui_toast_esm/* useToast */.pm)();
    var router = (0,next_router.useRouter)();
    var defaultSortMetadata = category === null || category === void 0 ? void 0 : (ref = category.article) === null || ref === void 0 ? void 0 : (ref1 = ref.metadata) === null || ref1 === void 0 ? void 0 : ref1.find(function(x) {
        return x.key === "default-sort";
    });
    var extractedArray = defaultSortMetadata === null || defaultSortMetadata === void 0 ? void 0 : defaultSortMetadata.value.match(/'([^']+)'/);
    var defaultSort = extractedArray ? extractedArray[1] : "best-match";
    var ref11 = (0,useDeclinedOrderDiscountVoucher/* useDeclinedOrderDiscountVoucher */.V)(), declinedVoucherCodeParam = ref11.declinedVoucherCodeParam, voucherValid = ref11.voucherValid;
    (0,react.useEffect)(function() {
        if (declinedVoucherCodeParam && voucherValid) {
            toast({
                duration: 3000,
                position: "top-right",
                render: function() {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
                        alignItems: "center",
                        backgroundColor: "var(--chakra-colors-tertiary)",
                        boxShadow: "dark-lg",
                        color: "white",
                        display: "flex",
                        flexDir: "row",
                        gap: 2,
                        padding: 3,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ai/* AiTwotoneInfoCircle */.v6R, {}),
                            "Your discount will be applied at Checkout.",
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ai/* AiOutlineClose */.oHP, {
                                cursor: "pointer",
                                onClick: function() {
                                    return toast.closeAll();
                                }
                            })
                        ]
                    });
                }
            });
        }
    }, [
        voucherValid
    ]);
    if (!category && !isSearchPage) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(legacy.NotFound, {});
    }
    var track = (0,TikTokPixelProvider/* useTikTokPixelContext */.n)().track;
    (0,react.useEffect)(function() {
        var handleRouteChange = function() {
            var pathname = router.pathname, query = router.query;
            var searchTerm = query === null || query === void 0 ? void 0 : query.keyword;
            if (pathname.includes("search") && searchTerm) {
                track("Search", {
                    query: Array.isArray(searchTerm) ? searchTerm.join(", ") : searchTerm
                });
            }
        };
        router.events.on("routeChangeComplete", handleRouteChange);
        return function() {
            router.events.off("routeChangeComplete", handleRouteChange);
        };
    }, [
        router,
        track
    ]);
    var ref12 = (0,useProductFiltering/* default */.Z)(), clientFiltered = ref12.clientFiltered, filters = ref12.filters, pricesFilter = ref12.pricesFilter, locationFilter = ref12.locationFilter, handleClearFilters = ref12.handleClearFilters, handleFiltersChange = ref12.handleFiltersChange, handlePricesFilter = ref12.handlePricesFilter, handleLocationFilter = ref12.handleLocationFilter, handleDeliveryFilter = ref12.handleDeliveryFilter, deliveryFilter = ref12.deliveryFilter, hasDeliveryFilter = ref12.hasDeliveryFilter, handleOrderChange = ref12.handleOrderChange, keyword = ref12.keyword, setKeyword = ref12.setKeyword;
    var ref13 = (0,useProductLoading/* useProductLoading */.v)({
        ssrData: category === null || category === void 0 ? void 0 : (ref2 = category.products) === null || ref2 === void 0 ? void 0 : ref2.products,
        ids: isSearchPage ? {} : {
            categoryId: category === null || category === void 0 ? void 0 : category.id
        },
        filters: filters,
        hasDeliveryFilter: hasDeliveryFilter,
        clientFiltered: clientFiltered
    }), products = ref13.products, loading = ref13.loading, pageInfo = ref13.pageInfo, numberOfProducts = ref13.numberOfProducts, handleLoadMore = ref13.handleLoadMore, loadMoreError = ref13.loadMoreError;
    var ref14 = (0,react.useState)(function() {
        return defaultSort;
    }), activeSortOption = ref14[0], setActiveSortOption = ref14[1];
    var mapSortToBackend = function(sort) {
        switch(sort){
            case "price-lowest":
                return "price";
            case "price-highest":
                return "-price";
            case "oldest":
                return "created_at";
            case "newest":
                return "-created_at";
            case "best-match":
                return null; // Backend expects `null` for best match
            default:
                return sort; // Fallback in case of unexpected values
        }
    };
    var ref15;
    filters.sortBy = (ref15 = mapSortToBackend(activeSortOption)) !== null && ref15 !== void 0 ? ref15 : filters.sortBy;
    var onSortChange = function(newSort) {
        setActiveSortOption(newSort); // Update user-facing state
        handleOrderChange({
            value: newSort
        });
    };
    var canonicalRef = category && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((head_default()), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
            rel: "canonical",
            href: "".concat(constants/* siteUrl */.or).concat(router.asPath)
        })
    });
    var title = isSearchPage ? keyword ? 'Results for "'.concat(keyword, '"') : "All Items for Rent" : category === null || category === void 0 ? void 0 : (ref3 = category.details) === null || ref3 === void 0 ? void 0 : ref3.name;
    var description = isSearchPage ? "Search results: ".concat(keyword || "") : category === null || category === void 0 ? void 0 : (ref4 = category.details) === null || ref4 === void 0 ? void 0 : ref4.seoDescription;
    var seoTitle = isSearchPage ? "Search results: ".concat(keyword || "") : category === null || category === void 0 ? void 0 : (ref5 = category.details) === null || ref5 === void 0 ? void 0 : ref5.seoTitle;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(legacy.MetaWrapper, {
        meta: {
            description: description || "",
            title: seoTitle || "",
            type: isSearchPage ? "search" : "product.category",
            url: constants/* ssrMode */.$m ? __webpack_require__.g.location.href : window.location.href,
            image: (category === null || category === void 0 ? void 0 : (ref6 = category.details) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.backgroundImage) === null || ref7 === void 0 ? void 0 : ref7.url) || (products === null || products === void 0 ? void 0 : products.length) && ((ref8 = products[0].thumbnail2x) === null || ref8 === void 0 ? void 0 : ref8.url)
        },
        children: [
            canonicalRef,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductListPage/* ProductListPage */.L, {
                title: title || "",
                seoDescription: (category === null || category === void 0 ? void 0 : (ref9 = category.details) === null || ref9 === void 0 ? void 0 : ref9.seoDescription) || "",
                textContent: category === null || category === void 0 ? void 0 : (ref10 = category.details) === null || ref10 === void 0 ? void 0 : ref10.description,
                attributes: attributes,
                clearFilters: handleClearFilters,
                products: products,
                displayLoader: !products.length && loading,
                hasNextPage: !!(pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.hasNextPage),
                numberOfProducts: numberOfProducts,
                activeSortOption: filters.sortBy,
                filters: filters,
                onAttributeFiltersChange: handleFiltersChange,
                onLoadMore: handleLoadMore,
                loadMoreError: loadMoreError,
                activeFilters: Object.keys((filters === null || filters === void 0 ? void 0 : filters.attributes) || {}).length,
                // onOrder={handleOrderChange}
                onOrder: function(option) {
                    return onSortChange((option === null || option === void 0 ? void 0 : option.value) || null);
                },
                pricesFilter: pricesFilter,
                setPricesFilter: handlePricesFilter,
                locationFilter: locationFilter,
                setLocationFilter: handleLocationFilter,
                deliveryFilter: deliveryFilter,
                setDeliveryFilter: handleDeliveryFilter,
                keyword: keyword,
                setKeyword: setKeyword,
                isFetching: loading
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/views/Category/index.tsx



/***/ }),

/***/ 12096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SearchView; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./src/views/Category/index.tsx + 1 modules
var Category = __webpack_require__(52921);
;// CONCATENATED MODULE: ./src/views/Search/SearchView.tsx




var SearchView = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Category/* CategoryView */.I, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        isSearchPage: true
    }));
};

;// CONCATENATED MODULE: ./src/views/Search/index.tsx



/***/ })

}]);